import React, { useState, useEffect } from "react";
import { ArrowLeft, Image, Plus, X, CircleCheckBig, Trash, ChevronsUpDown, CheckCircle, XCircle, Clock } from "lucide-react";
import {
  getBase64FromDataURL,
  readFileAsDataURL,
} from "./helper";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { crateExpense, fetchBankDetails, uploadBillswithImage, createEmployeeExpenseReimbursement, fetchAllModel, notifyExpenseSubmission } from "../../services/expense";
import { toast } from 'sonner'
import { createHubsetupExpense, uploadHubSetupBill } from "../../services/hubsetup";
import { getAvailableEmployeeBillOptions, getSelectableMonths, getTravelSelectableMonths } from "./utils";
import Modal from "../../components/Modal";
import BillManagementUI from "./BillGeneratingModalChild";
import {
  clearIndexedFieldErrors,
  EMPLOYEE_EMPTY_BILL,
  HUB_EMPTY_BILL,
  validateEmployeeBills,
  validateHubBills,
} from "./validation";

import { API_URL as BASE_URL } from "../../config";
import { APP_LOGO_PUBLIC_SRC, TITLE_HEADING_NAME } from "../../config/branding";

const reimbursementOptions = {
  hubs: "Hubs Reimbursement",
  employees: "Travel Reimbursement",
  hubsetup: "Hub Setup Reimbursement"
};

const HUB_STEPS = ["Review info", "Upload bills", "Bank info", "Complete"];

const glassPanelClass =
  "rounded-3xl border border-white/10 bg-slate-900/60 p-6 shadow-2xl shadow-black/40 backdrop-blur-2xl";
const fieldClass =
  "w-full rounded-2xl border border-white/10 bg-slate-950/60 px-4 py-3 text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-400/50 transition disabled:cursor-not-allowed disabled:opacity-50";
const selectClass = `${fieldClass} appearance-none pr-12`;
const sectionTitleClass = "text-xl font-semibold text-slate-100";

const HUB_BILL_OPTIONS = [
  { value: "electricity", label: "Electricity bill" },
  { value: "water", label: "Water bill" },
  { value: "stationery", label: "Stationery" },
  { value: "internet", label: "Internet" },
  { value: "house_keeping", label: "House Keeping" },
  { value: "miscellaneous", label: "Miscellaneous" },
  { value: "dc_image", label: "DC Image" },
  { value: "pest_control", label: "Pest Control" },
];

const EMPLOYEE_BILL_OPTIONS = [
  { value: "accommodation", label: "Accommodation" },
  { value: "travel", label: "Travel" },
  { value: "food", label: "Food" },
  { value: "local_conveyance", label: "Local Conveyance" },
  { value: "miscellaneous", label: "Miscellaneous" },
];

// Helper function to format claim ID for display
const formatClaimId = (claimId) => {
  if (!claimId) return '';
  // Extract only numeric characters from the claim ID
  const numericChars = claimId.replace(/\D/g, '');
  // Take the last 8 numeric digits (or all if less than 8)
  const lastNumericDigits = numericChars.slice(-8);
  // Pad with leading zeros to always show 8 digits
  return lastNumericDigits.padStart(8, '0');
};

const TimelineItem = ({ title, status }) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'complete':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'error':
        return <XCircle className="w-5 h-5 text-red-500" />;
      default:
        return <Clock className="w-5 h-5 text-yellow-500 animate-spin" />;
    }
  };

  return (
    <div className="flex items-center mb-4">
      <div className="flex-shrink-0 mr-2">
        {getStatusIcon()}
      </div>
      <div className="flex-grow">
        <p className={`text-sm ${status === 'complete' ? 'text-green-500' : status === 'error' ? 'text-red-500' : 'text-yellow-500'}`}>
          {title}
        </p>
      </div>
    </div>
  );
};

const Timeline = ({ children }) => {
  return (
    <div className="border-l-2 border-gray-700 pl-4">
      {children}
    </div>
  );
};

const initialFormState = {
  employee_id: "",
  hub_name: "",
  month: ""
};

const Expense = () => {

  const [searchParams] = useSearchParams();
  const [reimbursementType, setReimbursementType] = useState('hubs');
  const [uploadStatus, setUploadStatus] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [currentEmployeeStep, setCurrentEmployeeStep] = useState(1);
  const [currentHubsetupStep, setCurrentHubsetupStep] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [isEmployeeUploading, setIsEmployeeUploading] = useState(false);

  const [hubs, setHubs] = useState([])
  const [reviewInfo, setReviewInfo] = useState({
    employee_code: '',
    hub_name: '',
    name: '',
    email: '',
    month: '',
    model: '',
    travel_from_date: '',
    travel_to_date: '',
    travel_reason: '',
    travel_allowed_by: ''
  })
  const [formData, setFormData] = useState([{ ...HUB_EMPTY_BILL }]);
  const [models, setModels] = useState([]);

  const [formDataHubsetup, setFormDataHubsetup] = useState(initialFormState);

  const [formDataEmployee, setFormDataEmployee] = useState([{ ...EMPLOYEE_EMPTY_BILL }]);

  const [expenses, setExpenses] = useState([{ image: null, preview: null, baseAmount: '', gstAmount: '', totalAmount: '', date: '', user_remarks: '', bill_type: 'vendor' }]);


  const [bankInfo, setBankInfo] = useState({
    bank_name: null,
    account_number: null,
    reenter_account_number: null,
    account_holder_name: '',
    ifsc_code: null
  })
  const [formErrors, setFormErrors] = useState({});
  const [formEmployeeErrors, setFormEmployeeErrors] = useState({});
  const [reviewErrors, setReviewErrors] = useState({});
  const [isBankInfoExist, setBankInfoExist] = useState(true);
  const [timelineItems, setTimelineItems] = useState([]);
  const [error, setError] = useState(null);
  const [currentMonths, setCurrentMonths] = useState([]);
  const [claimId, setClaimId] = useState(null);

  const fetchModel = async () => {
    try {
      const response = await fetchAllModel();
      // console.log("response-mode",response.data )
      setModels(response.data);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  // useEffect(() => {
  //   setCurrentMonths(getLastFourMonths());
  // }, []);
  useEffect(() => {
    setCurrentMonths(
      reimbursementType === 'employees' ? getTravelSelectableMonths() : getSelectableMonths(),
    );
  }, [reimbursementType]);

  useEffect(() => {
    fetchModel()
  }, []);


  const toggleModal = () => {
    setIsModalOpen(!isOpenModal);
  };
  const handleReviewInfoChange = (event) => {
    const { name, value } = event.target;
    setReviewInfo(prevInfo => ({
      ...prevInfo,
      [name]: value
    }));
  };

  const handleBankInfo = (event) => {
    const { name, value } = event.target;
    setBankInfo(prevInfo => ({
      ...prevInfo,
      [name]: value
    }));
  }

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus()
    }, 0)
  }

  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prevData => {
          const newData = [...prevData];
          newData[index] = {
            ...newData[index],
            image: file, 
            preview: reader.result,
            fileType: file.type,
            fileName: file.name
          };
          return newData;
        });
        setFormErrors((prevErrors) => clearIndexedFieldErrors(prevErrors, index, ["image"]));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEmployeeFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormDataEmployee(prevData => {
          const newData = [...prevData];
          newData[index] = {
            ...newData[index],
            image: file, 
            preview: reader.result, 
            bills_attached: true,
            fileType: file.type,
            fileName: file.name
          };
          return newData;
        });
        setFormEmployeeErrors((prevErrors) => clearIndexedFieldErrors(prevErrors, index, ["image"]));
      };
      reader.readAsDataURL(file);
    }
  }

  const handleHubsetupFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setExpenses(prevData => {
          const newData = [...prevData];
          newData[index] = {
            ...newData[index],
            image: file, preview: reader.result
          };
          return newData;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEmployeeInputChange = (index, e) => {
    const { name, value } = e.target;
    setFormDataEmployee(prevData => {
      const newData = [...prevData];
      newData[index] = { ...newData[index], [name]: value };

      // Auto-calculate total amount when baseAmount or gstAmount changes
      if (name === 'baseAmount' || name === 'gstAmount') {
        const baseAmount = parseFloat(newData[index].baseAmount) || 0;
        const gstAmount = parseFloat(newData[index].gstAmount) || 0;
        newData[index].totalAmount = (baseAmount + gstAmount).toFixed(2);
      }
      return newData;
    });
    setFormEmployeeErrors((prevErrors) =>
      clearIndexedFieldErrors(
        prevErrors,
        index,
        name === "baseAmount" || name === "gstAmount" ? [name, "totalAmount"] : [name],
      ),
    );
  }

  const removeEmployeeSection = (index) => {
    setFormDataEmployee(prevData => prevData.filter((_, i) => i !== index));
    // Also remove any errors associated with this form
    setFormEmployeeErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      delete newErrors[`image-${index}`];
      delete newErrors[`type-${index}`];
      delete newErrors[`description-${index}`];
      delete newErrors[`date-${index}`];
      delete newErrors[`baseAmount-${index}`];
      delete newErrors[`gstAmount-${index}`];
      delete newErrors[`totalAmount-${index}`];
      return newErrors;
    });
  };

  const handleHubsetupInputChange = (event) => {
    const { name, value } = event.target;
    setFormDataHubsetup((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    setFormData(prevData => {
      const newData = [...prevData];
      newData[index] = { ...newData[index], [name]: value };
      // Auto-calculate total amount when baseAmount or gstAmount changes
      if (name === 'baseAmount' || name === 'gstAmount') {
        const baseAmount = parseFloat(newData[index].baseAmount) || 0;
        const gstAmount = parseFloat(newData[index].gstAmount) || 0;
        newData[index].totalAmount = (baseAmount + gstAmount).toFixed(2);
      }
      return newData;
    });
    setFormErrors((prevErrors) =>
      clearIndexedFieldErrors(
        prevErrors,
        index,
        name === "baseAmount" || name === "gstAmount" ? [name, "totalAmount"] : [name],
      ),
    );
  };

  const removeImage = (index) => {
    setFormData(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        image: null,
        preview: null
      };
      return newData;
    });
  };

  const removeExpenseImage = (index) => {
    setExpenses(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        image: null,
        preview: null
      };
      return newData;
    });
  }

  const removeEmployeeImage = (index) => {
    setFormDataEmployee(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        image: null,
        preview: null,
        bills_attached: false,
        fileType: undefined,
        fileName: undefined,
      };
      return newData;
    });
  }

  const addSection = () => {
    setFormData(prevData => [...prevData, { ...HUB_EMPTY_BILL }]);
  };

  const employeeAddSection = () => {
    setFormDataEmployee(prevData => [...prevData, { ...EMPLOYEE_EMPTY_BILL }])
  }

  const removeSection = (index) => {
    setFormData(prevData => prevData.filter((_, i) => i !== index));
    // Also remove any errors associated with this form
    setFormErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      delete newErrors[`image-${index}`];
      delete newErrors[`type-${index}`];
      delete newErrors[`date-${index}`];
      delete newErrors[`baseAmount-${index}`];
      delete newErrors[`gstAmount-${index}`];
      delete newErrors[`totalAmount-${index}`];
      return newErrors;
    });
  };

  const onReviewInfoSubmit = async () => {
    const errors = {};
    if (!reviewInfo.employee_code) errors[`employee_code`] = 'Employee code is required';
    if (!reviewInfo.hub_name) errors[`hub_name`] = 'Hub is required';
    if (!reviewInfo.month) errors[`month`] = 'Month is required';
    if (Object.keys(errors).length > 0) {
      setReviewErrors(errors);
      return;
    }
    setCurrentStep(2);
  }

  const onReviewEmployeeInfoSubmit = async () => {
    const errors = {};
    if (!reviewInfo.employee_code) errors[`employee_code`] = 'Employee code is required';
    if (!reviewInfo.month) errors[`month`] = 'Month is required';
    if (!reviewInfo.travel_from_date) errors[`travel_from_date`] = 'Travel start date is required';
    if (!reviewInfo.travel_to_date) errors[`travel_to_date`] = 'Travel end date is required';
    if (!reviewInfo.travel_reason?.trim()) errors[`travel_reason`] = 'Travel reason is required';
    if (!reviewInfo.travel_allowed_by?.trim()) errors[`travel_allowed_by`] = 'Approver name is required';
    if (reviewInfo.travel_from_date && reviewInfo.travel_to_date) {
      const fromDate = new Date(reviewInfo.travel_from_date);
      const toDate = new Date(reviewInfo.travel_to_date);
      if (fromDate > toDate) {
        errors[`travel_to_date`] = 'Travel end date must be after start date';
      }
    }
    if (Object.keys(errors).length > 0) {
      setReviewErrors(errors);
      return;
    }
    setCurrentEmployeeStep(2)
  }

  const onBankInfoSubmit = async () => {
    setCurrentStep(4);
  }

  const onEmployeeBankInfoSubmit = async () => {
    setCurrentEmployeeStep(4);
  }

  const handleNextClick = () => {
    const errors = {};
    if (!formDataHubsetup.employee_id.trim()) {
      errors.employee_id = "Employee ID is required";
    }
    if (!formDataHubsetup.hub_name.trim()) {
      errors.hub_name = "Hub Name is required";
    }

    if (!formDataHubsetup.month.trim()) {
      errors.hub_name = "Hub Name is required";
    }

    if (Object.keys(errors).length === 0) {
      setCurrentHubsetupStep(2);
      setFormErrors({});
    } else {
      setFormErrors(errors);
    }
  };


  const handleHubsetupExpensesUpload = async () => {
    setIsLoading(true);
    setError(null);
    setUploadStatus("Uploading...");

    try {
      const response = await createHubsetupExpense({
        employee_id: formDataHubsetup?.employee_id,
        hub_name: formDataHubsetup?.hub_name,
        month: formDataHubsetup?.month,
        type: "setup_reimbursement"
      });

      const newExpenseId = response.data.id;
      setClaimId(response.data.claim_id || response.data.id);

      await Promise.all(
        expenses.map(async ({ image, preview, ...data }, index) => {
          if (parseFloat(data.baseAmount) < 0 || parseFloat(data.gstAmount) < 0 || parseFloat(data.totalAmount) < 0) {
            throw new Error('Please enter positive numbers for all amount fields.');
          }

          try {
            let payload = {
              ...data,
              employee_id: formDataHubsetup?.employee_id,
              amount: data.totalAmount // Send totalAmount as amount for backward compatibility
            };

            if (image) {
              const dataURL = await readFileAsDataURL(image);
              const base64Image = getBase64FromDataURL(dataURL);
              payload.image = base64Image;
              payload.fileType = data.fileType || image.type;
              payload.fileName = data.fileName || image.name;
            }

            const response = await uploadHubSetupBill(payload, newExpenseId);
            console.log(response, `-- upload response for bill ${index + 1} --`);
          } catch (error) {
            toast.error(`Failed to upload bill ${index + 1}: ${error.message}`);
            throw error; // Re-throw to mark the overall process as failed
          }
        })
      );

      const fetchedBankInfo = await fetchBankDetails(formDataHubsetup?.employee_id);
      if (!fetchedBankInfo) {
        setBankInfoExist(false);
      }
      setBankInfo({
        bank_name: fetchedBankInfo?.bank_name || null,
        account_number: fetchedBankInfo?.account_number || null,
        account_holder_name: fetchedBankInfo?.account_holder_name || null,
        ifsc_code: fetchedBankInfo?.ifsc_code || null
      });

      await notifyExpenseSubmission(newExpenseId);

      setCurrentHubsetupStep(3);
      setUploadStatus("Upload successful");
    } catch (error) {
      setError("Upload failed. Please try again.");
      setUploadStatus("");
      console.error("Upload error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpload = async () => {
    // Validate all sections
    const errors = validateHubBills(formData);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setUploadStatus("Please fill in all required fields correctly.");
      return;
    }
    setIsUploading(true);
    setUploadStatus("Uploading...");
    setTimelineItems([]);

    try {
      // Step 1: Create Expense
      setTimelineItems(prev => [...prev, { title: 'Creating Expense', status: 'in-progress' }]);
      const response = await crateExpense({ employee_id: reviewInfo?.employee_code, hub_name: reviewInfo?.hub_name, month: reviewInfo?.month });
      const newExpenseId = response.data.id;
      setClaimId(response.data.claim_id || response.data.id);
      setTimelineItems(prev => prev.map(item =>
        item.title === 'Creating Expense' ? { ...item, status: 'complete' } : item
      ));

      // Step 2: Upload Bills
      setTimelineItems(prev => [...prev, { title: 'Uploading Bills', status: 'in-progress' }]);
      await Promise.all(
        formData.map(async ({ image, preview, ...data }, index) => {
          if (parseFloat(data.baseAmount) < 0 || parseFloat(data.gstAmount) < 0 || parseFloat(data.totalAmount) < 0) {
            throw new Error('Please enter positive numbers for all amount fields.');
          }

          try {
            const dataURL = await readFileAsDataURL(image);
            const base64Image = getBase64FromDataURL(dataURL);
            const payload = {
              ...data,
              image: base64Image,
              amount: data.totalAmount,
              fileType: data.fileType || image.type,
              fileName: data.fileName || image.name,
            };
            const response = await uploadBillswithImage(newExpenseId, payload, reviewInfo.employee_code);
            if (response?.error) {
              throw new Error(response.error?.message || response.error || 'Upload failed');
            }
          } catch (error) {
            const message = error.response?.data?.error ?? error.response?.data?.message ?? error.message ?? 'Upload failed';
            toast.error(`Failed to upload bill ${index + 1}: ${message}`);
            throw error;
          }
        })
      );
      setTimelineItems(prev => prev.map(item =>
        item.title === 'Uploading Bills' ? { ...item, status: 'complete' } : item
      ));

      await notifyExpenseSubmission(newExpenseId);

      // Step 3: Fetch Bank Details
      setTimelineItems(prev => [...prev, { title: 'Fetching Bank Details', status: 'in-progress' }]);
      const fetchedBankInfo = await fetchBankDetails(reviewInfo.employee_code);
      if (!fetchedBankInfo) {
        setBankInfoExist(false);
      }
      const initialInfo = {
        bank_name: fetchedBankInfo?.bank_name || null,
        account_number: fetchedBankInfo?.account_number || null,
        account_holder_name: fetchedBankInfo?.account_holder_name || null,
        ifsc_code: fetchedBankInfo?.ifsc_code || null
      };
      setBankInfo(initialInfo);
      setTimelineItems(prev => prev.map(item =>
        item.title === 'Fetching Bank Details' ? { ...item, status: 'complete' } : item
      ));

      setUploadStatus("Upload successful! Analysis complete.");
      setCurrentStep(3);
    } catch (error) {
      setUploadStatus("Upload failed. Please try again.");
      console.error("Error uploading images:", error);
      setTimelineItems(prev => prev.map(item =>
        item.status === 'in-progress' ? { ...item, status: 'error' } : item
      ));
    } finally {
      setIsUploading(false);
    }
  };

  const onEmployeeReimbursementSubmit = async () => {
    // console.log("hey im invoking")
    const errors = validateEmployeeBills(formDataEmployee);

    if (Object.keys(errors).length > 0) {
      setFormEmployeeErrors(errors);
      return;
    }
    setIsEmployeeUploading(true);
    setTimelineItems([]);

    try {
      // Step 1: Create Employee Expense Reimbursement
      setTimelineItems(prev => [...prev, { title: 'Creating Expense Reimbursement', status: 'in-progress' }]);
      const expensesData = await Promise.all(
        formDataEmployee.map(async ({ image, preview, ...data }) => {
          if (parseFloat(data.baseAmount) < 0 || parseFloat(data.gstAmount) < 0 || parseFloat(data.totalAmount) < 0) {
            throw new Error('Please enter positive numbers for all amount fields.');
          }

          const dataURL = await readFileAsDataURL(image);
          const base64Image = getBase64FromDataURL(dataURL);

          return {
            type: data.type,
            amount: data.totalAmount,
            description: data.description || '',
            location: data.location || '',
            bills_attached: data.bills_attached || !!image,
            date: data.date,
            base_amount: data.baseAmount,
            gst_amount: data.gstAmount,
            bill_type: data.bill_type || 'vendor',
            image: base64Image,
            fileType: data.fileType || image.type,
            fileName: data.fileName || image.name,
          };
        })
      );
      const response = await createEmployeeExpenseReimbursement({
        employee_id: reviewInfo?.employee_code,
        month: reviewInfo?.month,
        model: reviewInfo?.model,
        travel_from_date: reviewInfo?.travel_from_date,
        travel_to_date: reviewInfo?.travel_to_date,
        travel_reason: reviewInfo?.travel_reason,
        travel_allowed_by: reviewInfo?.travel_allowed_by,
        expenses: expensesData
      });
      setClaimId(response.data.claim_id || response.data.id);
      setTimelineItems(prev => prev.map(item =>
        item.title === 'Creating Expense Reimbursement' ? { ...item, status: 'complete' } : item
      ));

      // Step 3: Fetch Bank Details
      setTimelineItems(prev => [...prev, { title: 'Fetching Bank Details', status: 'in-progress' }]);
      const fetchedBankInfo = await fetchBankDetails(reviewInfo.employee_code);

      if (!fetchedBankInfo) {
        setBankInfoExist(false);
      }

      const initialInfo = {
        bank_name: fetchedBankInfo?.bank_name || null,
        account_number: fetchedBankInfo?.account_number || null,
        account_holder_name: fetchedBankInfo?.account_holder_name || null,
        ifsc_code: fetchedBankInfo?.ifsc_code || null
      };

      setBankInfo(initialInfo);
      setTimelineItems(prev => prev.map(item =>
        item.title === 'Fetching Bank Details' ? { ...item, status: 'complete' } : item
      ));

      setCurrentEmployeeStep(3);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to submit travel reimbursement";
      toast.error(errorMessage);
      setTimelineItems(prev => prev.map(item =>
        item.status === 'in-progress' ? { ...item, status: 'error' } : item
      ));
    } finally {
      setIsEmployeeUploading(false);
    }
  }

  const removeExpense = (index) => {
    const updatedExpenses = expenses.filter((_, i) => i !== index);
    setExpenses(updatedExpenses);
  };

  const addExpense = () => {
    setExpenses([...expenses, { baseAmount: '', gstAmount: '', totalAmount: '', user_remarks: '', bill_type: 'vendor' }]);
  };


  const handleExpenseChange = (index, e) => {
    const { name, value } = e.target;
    const updatedExpenses = expenses.map((expense, i) => {
      if (i === index) {
        const updatedExpense = { ...expense, [name]: value };
        // Auto-calculate total amount when baseAmount or gstAmount changes
        if (name === 'baseAmount' || name === 'gstAmount') {
          const baseAmount = parseFloat(updatedExpense.baseAmount) || 0;
          const gstAmount = parseFloat(updatedExpense.gstAmount) || 0;
          updatedExpense.totalAmount = (baseAmount + gstAmount).toFixed(2);
        }
        return updatedExpense;
      }
      return expense;
    });
    setExpenses(updatedExpenses);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const id = searchParams.get("id");
      if (id) {
        try {
          const response = await axios.get(
            `${BASE_URL}/employee/${id}`,
            {
              headers: {
                "ngrok-skip-browser-warning": "true",
              },
            }
          );
          const userData = response.data.data;

          setReviewInfo((prevState) => ({
            ...prevState,
            employee_code: userData?.id || "",
            name: userData?.name,
            email: userData?.email || ""
          }));
          setFormDataHubsetup((prevState) => ({
            ...prevState,
            employee_id: userData?.id || "",
            name: userData?.name
          }));
          let designation = userData?.designation;
          let hubRole = ""

          if (!designation || designation === 'Hub Incharge') hubRole = 'hubsInCharge';
          else if (designation === 'Level 1') hubRole = "hubsLevel1";
          else if (designation === 'Level 3') hubRole = "hubsLevel3";
          else hubRole = "hubsLevel2"

          // let hubIds = userData[hubRole]
          // console.log(userData[hubRole], "--- user data ---")
          setHubs(userData[hubRole]);
        } catch (err) {
          toast.error('Failed to fetch Employee data. Please try again.')
          console.error("Error fetching user data:", err);
        }
      }
      setIsLoading(false);
    };

    fetchUserData();
  }, [searchParams]);


  const renderReviewInformation = () => (
    <div className="grid gap-6 xl:grid-cols-[360px_minmax(0,1fr)]">
      <div className={`${glassPanelClass} space-y-6 h-full`}>
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="space-y-1">
            <p className="text-xs uppercase tracking-[0.4em] text-blue-200/80">Workflow</p>
            <h3 className="text-2xl font-semibold text-white">Hubs reimbursement</h3>
            <p className="text-sm text-slate-300/90">Submit monthly operational expenses in a guided flow.</p>
          </div>
          <div className="relative w-full sm:w-64">
            <select
              value={reimbursementType}
              onChange={(e) => setReimbursementType(e.target.value)}
              className={`${selectClass} bg-slate-950/70 font-medium`}
            >
              {Object.entries(reimbursementOptions).map(([value, label]) => (
                <option key={value} value={value} className="bg-slate-900">
                  {label}
                </option>
              ))}
            </select>
            <ChevronsUpDown className="absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          </div>
        </div>
        <Stepper currentStep={currentStep} steps={HUB_STEPS} />
        <div className="grid gap-4 sm:grid-cols-3 text-center">
          <InsightCard title="Step 1" subtitle="Review details" icon="1" active />
          <InsightCard title="Step 2" subtitle="Bill upload" icon="2" />
          <InsightCard title="Step 3" subtitle="Bank info" icon="3" />
        </div>
      </div>

      <div className={`${glassPanelClass} space-y-6`}>
        <div className="space-y-1">
          <p className="text-xs uppercase tracking-[0.4em] text-blue-200/80">Step 1 of 3</p>
          <h3 className={sectionTitleClass}>Review your information</h3>
          <p className="text-sm text-slate-300/90">We pre-fill details from your employee record.</p>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center rounded-2xl border border-white/5 bg-slate-950/40 p-6">
            <div className="flex items-center gap-3">
              <div className="h-6 w-6 animate-spin rounded-full border-2 border-blue-500/60 border-t-transparent" />
              <span className="text-sm text-slate-300">Fetching your profile...</span>
            </div>
          </div>
        ) : !reviewInfo.employee_code ? (
          <div className="rounded-2xl border border-red-500/30 bg-red-500/10 p-6" role="alert">
            <p className="text-sm font-semibold text-red-200">Employee information not found</p>
            <p className="text-sm text-red-300/80">
              You must be part of the organization to submit a reimbursement request. Please contact your administrator for assistance.
            </p>
          </div>
        ) : (
          <>
            <div className="grid gap-6">
              <div className="space-y-2">
                <label htmlFor="employee_code" className="text-sm font-medium text-slate-200">
                  Employee code
                </label>
                <input
                  type="text"
                  id="employee_code"
                  name="employee_code"
                  value={reviewInfo.employee_code}
                  onChange={handleReviewInfoChange}
                  className={`${fieldClass} font-semibold tracking-wide`}
                  disabled
                />
                {reviewErrors["employee_code"] && <FieldError message={reviewErrors["employee_code"]} />}
              </div>

              <div className="space-y-2">
                <label htmlFor="hub_name" className="text-sm font-medium text-slate-200">
                  Hub
                </label>
                {hubs && hubs.length > 0 ? (
                  <div className="relative">
                    <select
                      id="hub_name"
                      name="hub_name"
                      value={reviewInfo.hub_name}
                      onChange={handleReviewInfoChange}
                      className={`${selectClass} bg-slate-950/70`}
                    >
                      <option value="">Select a hub</option>
                      {hubs.map((hub) => (
                        <option key={hub.id} value={hub.id}>
                          {`${hub.location} (${hub.state} - ${hub.zone})`}
                        </option>
                      ))}
                    </select>
                    <ChevronsUpDown className="absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                  </div>
                ) : (
                  <div className="rounded-2xl border border-amber-400/30 bg-amber-400/10 p-4 text-left" role="alert">
                    <p className="text-sm font-semibold text-amber-200">No hubs assigned</p>
                    <p className="text-sm text-amber-100/80">There are no hubs attached to your name. Contact your administrator.</p>
                  </div>
                )}
                {reviewErrors["hub_name"] && <FieldError message={reviewErrors["hub_name"]} />}
              </div>

              <div className="space-y-2">
                <label htmlFor="month" className="text-sm font-medium text-slate-200">
                  Select month
                </label>
                <div className="relative">
                  <select
                    id="month"
                    name="month"
                    value={reviewInfo.month}
                    onChange={handleReviewInfoChange}
                    className={`${selectClass} bg-slate-950/70`}
                  >
                    <option value="">Select a month</option>
                    {currentMonths.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                  <ChevronsUpDown className="absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                </div>
                {reviewErrors["month"] && <FieldError message={reviewErrors["month"]} />}
              </div>
            </div>

            <button
              onClick={onReviewInfoSubmit}
              disabled={!reviewInfo.employee_code || !reviewInfo.hub_name || !reviewInfo.month || isLoading}
              className={`mt-4 w-full rounded-2xl px-6 py-4 text-base font-semibold transition ${reviewInfo.employee_code && reviewInfo.hub_name && reviewInfo.month && !isLoading
                  ? "bg-gradient-to-r from-blue-500 via-indigo-500 to-fuchsia-500 text-white shadow-lg shadow-blue-500/30 hover:scale-[1.01]"
                  : "bg-white/10 text-slate-400"
                }`}
            >
              {isLoading ? "Processing..." : "Continue to upload"}
            </button>
          </>
        )}
      </div>
    </div>
  );

  const renderEmployeeReviewInformation = () => (
    <div className="grid gap-6 xl:grid-cols-[320px_minmax(0,1fr)]">
      <div className={`${glassPanelClass} space-y-4`}>
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-gray-200">
            Select Reimbursement Type
          </label>
          <div className="relative">
            <select
              value={reimbursementType}
              onChange={(e) => setReimbursementType(e.target.value)}
              className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:bg-gray-750"
              style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
            >
              {Object.entries(reimbursementOptions).map(([value, label]) => (
                <option key={value} value={value} className="bg-gray-800">
                  {label}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <ChevronsUpDown className="w-5 h-5 text-gray-400" />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center space-x-2 py-2">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-sm font-semibold">
              1
            </div>
            <div className="w-12 h-0.5 bg-gray-600"></div>
            <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center text-gray-400 text-sm font-semibold">
              2
            </div>
            <div className="w-12 h-0.5 bg-gray-600"></div>
            <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center text-gray-400 text-sm font-semibold">
              3
            </div>
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-2xl font-bold text-white mb-2">Review Your Information</h3>
          <p className="text-gray-400 text-sm">Step 1 of 3</p>
        </div>
      </div>

      <div className={`${glassPanelClass} space-y-6`}>
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span className="ml-3 text-gray-300">Loading user data...</span>
          </div>
        ) : !reviewInfo.employee_code ? (
          <div className="bg-red-900/20 border border-red-500/30 rounded-xl p-6" role="alert">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-semibold text-red-400">Employee Information Not Found</h3>
                <p className="mt-1 text-sm text-red-300">You must be part of the organization to submit a reimbursement request. Please contact your administrator for assistance.</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="space-y-2">
              <label htmlFor="employee_code" className="block text-sm font-semibold text-gray-200">
                Employee Code
              </label>
              <input
                type="text"
                id="employee_code"
                name="employee_code"
                value={reviewInfo.employee_code}
                onChange={handleReviewInfoChange}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200"
                disabled
              />
              {reviewErrors['employee_code'] && (
                <p className="text-sm text-red-400 flex items-center">
                  <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {reviewErrors['employee_code']}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <label htmlFor="month" className="block text-sm font-semibold text-gray-200">
                Select Month
              </label>
              <div className="relative">
                <select
                  id="month"
                  name="month"
                  value={reviewInfo.month}
                  onChange={handleReviewInfoChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:bg-gray-750"
                  style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
                >
                  <option value="" className="bg-gray-800">Select a month</option>
                  {currentMonths.map((month) => (
                    <option key={month} value={month} className="bg-gray-800">
                      {month}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <ChevronsUpDown className="w-5 h-5 text-gray-400" />
                </div>
              </div>
              {reviewErrors['month'] && (
                <p className="text-sm text-red-400 flex items-center">
                  <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {reviewErrors['month']}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <label htmlFor="model" className="block text-sm font-semibold text-gray-200">
                Select Model
              </label>
              <div className="relative">
                <select
                  id="model"
                  name="model"
                  value={reviewInfo.model}
                  onChange={handleReviewInfoChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:bg-gray-750"
                  style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
                >
                  <option value="" className="bg-gray-800">Select a model</option>
                  {models.map((model) => (
                    <option key={model} value={model} className="bg-gray-800">
                      {model}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <ChevronsUpDown className="w-5 h-5 text-gray-400" />
                </div>
              </div>
              {reviewErrors['model'] && (
                <p className="text-sm text-red-400 flex items-center">
                  <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {reviewErrors['model']}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <label htmlFor="travel_from_date" className="block text-sm font-semibold text-gray-200">
                Travel from date
              </label>
              <input
                type="date"
                id="travel_from_date"
                name="travel_from_date"
                value={reviewInfo.travel_from_date}
                onChange={handleReviewInfoChange}
                max={new Date().toISOString().split('T')[0]}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {reviewErrors['travel_from_date'] && <p className="text-sm text-red-400">{reviewErrors['travel_from_date']}</p>}
            </div>

            <div className="space-y-2">
              <label htmlFor="travel_to_date" className="block text-sm font-semibold text-gray-200">
                Travel to date
              </label>
              <input
                type="date"
                id="travel_to_date"
                name="travel_to_date"
                value={reviewInfo.travel_to_date}
                onChange={handleReviewInfoChange}
                max={new Date().toISOString().split('T')[0]}
                min={reviewInfo.travel_from_date || undefined}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {reviewErrors['travel_to_date'] && <p className="text-sm text-red-400">{reviewErrors['travel_to_date']}</p>}
            </div>

            <div className="space-y-2">
              <label htmlFor="travel_reason" className="block text-sm font-semibold text-gray-200">
                Travel reason
              </label>
              <textarea
                id="travel_reason"
                name="travel_reason"
                value={reviewInfo.travel_reason}
                onChange={handleReviewInfoChange}
                rows={3}
                placeholder="Reason for travel (example: Hub audit from 1 to 5 May)"
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {reviewErrors['travel_reason'] && <p className="text-sm text-red-400">{reviewErrors['travel_reason']}</p>}
            </div>

            <div className="space-y-2">
              <label htmlFor="travel_allowed_by" className="block text-sm font-semibold text-gray-200">
              Visit Requester (person)
              </label>
              <input
                type="text"
                id="travel_allowed_by"
                name="travel_allowed_by"
                value={reviewInfo.travel_allowed_by}
                onChange={handleReviewInfoChange}
                placeholder="Example: X person"
                className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {reviewErrors['travel_allowed_by'] && <p className="text-sm text-red-400">{reviewErrors['travel_allowed_by']}</p>}
            </div>
          </div>
        )}

        {reviewInfo.employee_code && (
          <div className="pt-4">
            <button
              onClick={onReviewEmployeeInfoSubmit}
              disabled={!reviewInfo.employee_code || !reviewInfo.month || !reviewInfo.model || !reviewInfo.travel_from_date || !reviewInfo.travel_to_date || !reviewInfo.travel_reason?.trim() || !reviewInfo.travel_allowed_by?.trim() || isLoading}
              className={`w-full px-6 py-4 rounded-xl font-semibold text-lg transition-all duration-200 transform ${reviewInfo.employee_code && reviewInfo.month && reviewInfo.model && reviewInfo.travel_from_date && reviewInfo.travel_to_date && reviewInfo.travel_reason?.trim() && reviewInfo.travel_allowed_by?.trim() && !isLoading
                  ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 hover:scale-105 shadow-lg hover:shadow-xl'
                  : 'bg-gray-600 text-gray-400 cursor-not-allowed'
                }`}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Processing...
                </div>
              ) : (
                'Next'
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  )

  const renderImageUpload = () => (
    <div className={`${glassPanelClass} space-y-6`}>
      <h3 className="text-xl font-medium mb-4 text-gray-200 flex flex-col gap-6">
        <div className="flex w-full justify-between items-center">
          <p className="text-sm font-regular text-gray-100 opacity-65">
            Step 2 of 3
          </p>
          <button
            className={`
        text-[16px] font-regular flex gap-1 items-center
        ${isUploading
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-gray-100 opacity-65 hover:opacity-100'
              }
      `}
            onClick={() => !isUploading && setCurrentStep(1)}
            disabled={isUploading}
          >
            <ArrowLeft size={18} />
            Back
          </button>
        </div>
        <div className="flex items-center justify-between">
          Bill Upload
        </div>
      </h3>
      <div>
        {formData?.map((data, index) => (
          <div key={index} className="mb-8 p-4 border border-gray-700 rounded-lg">
            {formData?.length > 1 && (
              <button
                onClick={() => removeSection(index)}
                disabled={isUploading}
                className="p-1.5 bg-white rounded-full text-black hover:bg-white transition-colors mb-6"
              >
                <Trash size={16} />
              </button>
            )}
            <div className="mb-6">
              <label htmlFor={`image-${index}`} className="block mb-2 text-sm font-medium text-gray-300">
                Choose an image
              </label>
              {data?.preview ? (
                <div className="relative">
                  <img src={data.preview} alt="Preview" className="max-w-full h-auto rounded-lg shadow-md" />
                  <button
                    onClick={() => removeImage(index)}
                    className="absolute top-2 right-2 p-1 bg-red-500 rounded-full text-white hover:bg-red-600 transition-colors"
                    disabled={isUploading}
                  >
                    <X size={16} />
                  </button>
                </div>
              ) : (
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <Image size={26} className="mx-auto text-gray-400 mb-4" />
                    <div className="flex text-sm text-gray-400">
                      <label
                        htmlFor={`image-${index}`}
                        className={`relative cursor-pointer bg-gray-700 rounded-md font-medium text-blue-400 hover:text-blue-300 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500 ${isUploading ? 'cursor-not-allowed opacity-50' : ''}`}
                      >
                        <span className="p-2 rounded-lg">Upload a file</span>
                        <input
                          id={`image-${index}`}
                          name="image"
                          type="file"
                          accept="image/*,application/pdf"
                          onChange={(e) => handleFileChange(index, e)}
                          className="sr-only"
                          disabled={isUploading}
                        />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-400">PNG, JPG, PDF up to 10MB</p>
                  </div>
                </div>
              )}
              {formErrors[`image-${index}`] && (
                <p className="mt-1 text-sm text-red-500">{formErrors[`image-${index}`]}</p>
              )}
            </div>
            <div className="mb-4">
              <label htmlFor={`type-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
                Bill
              </label>
              <select
                id={`type-${index}`}
                name="type"
                value={data.type}
                onChange={(e) => handleInputChange(index, e)}
                className={`block w-full bg-[#1F1F1F] border ${formErrors[`type-${index}`] ? 'border-red-500' : 'border-[#373737]'
                  } rounded-md shadow-sm p-2 text-white ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={isUploading}
              >
                <option value="">Select a bill</option>
                {HUB_BILL_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {formErrors[`type-${index}`] && (
                <p className="mt-1 text-sm text-red-500">{formErrors[`type-${index}`]}</p>
              )}
            </div>
            <div className="mb-4">
              <label htmlFor={`billType-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
                Bill Type
              </label>
              <select
                id={`billType-${index}`}
                name="bill_type"
                value={data.bill_type}
                onChange={(e) => handleInputChange(index, e)}
                disabled={isUploading}
                className="block w-full bg-[#1F1F1F] border border-[#373737] rounded-md shadow-sm p-2 text-white"
              >
                <option value="vendor">Vendor</option>
                <option value="employee">Employee</option>
              </select>
            </div>
            <div className="mb-4">
              <label htmlFor={`baseAmount-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
                Base Amount
              </label>
              <input
                type="number"
                onWheel={numberInputOnWheelPreventChange}
                id={`baseAmount-${index}`}
                name="baseAmount"
                value={data.baseAmount !== 0 ? data.baseAmount : ''}
                onChange={(e) => handleInputChange(index, e)}
                disabled={isUploading}
                className={`block w-full bg-[#1F1F1F] border ${formErrors[`baseAmount-${index}`] ? 'border-red-500' : 'border-[#373737]'
                  } rounded-md shadow-sm p-2 text-white ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
              />
              {formErrors[`baseAmount-${index}`] && (
                <p className="mt-1 text-sm text-red-500">{formErrors[`baseAmount-${index}`]}</p>
              )}
            </div>
            <div className="mb-4">
              <label htmlFor={`gstAmount-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
                GST Amount
              </label>
              <input
                type="number"
                onWheel={numberInputOnWheelPreventChange}
                id={`gstAmount-${index}`}
                name="gstAmount"
                value={data.gstAmount !== 0 ? data.gstAmount : ''}
                onChange={(e) => handleInputChange(index, e)}
                disabled={isUploading}
                className={`block w-full bg-[#1F1F1F] border ${formErrors[`gstAmount-${index}`] ? 'border-red-500' : 'border-[#373737]'
                  } rounded-md shadow-sm p-2 text-white ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
              />
              {formErrors[`gstAmount-${index}`] && (
                <p className="mt-1 text-sm text-red-500">{formErrors[`gstAmount-${index}`]}</p>
              )}
            </div>
            <div className="mb-4">
              <label htmlFor={`totalAmount-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
                Total Amount
              </label>
              <input
                type="number"
                onWheel={numberInputOnWheelPreventChange}
                id={`totalAmount-${index}`}
                name="totalAmount"
                value={data.totalAmount !== 0 ? data.totalAmount : ''}
                onChange={(e) => handleInputChange(index, e)}
                disabled={true}
                className={`block w-full bg-[#1F1F1F] border ${formErrors[`totalAmount-${index}`] ? 'border-red-500' : 'border-[#373737]'
                  } rounded-md shadow-sm p-2 text-white opacity-75 cursor-not-allowed`}
              />
              {formErrors[`totalAmount-${index}`] && (
                <p className="mt-1 text-sm text-red-500">{formErrors[`totalAmount-${index}`]}</p>
              )}
            </div>
          </div>
        ))}
        <div className="flex flex-col space-y-4 mb-3 mt-6">
          <button
            type="button"
            className={`text-gray-900 bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-2.5 py-1.5 text-center inline-flex items-center justify-center ${isUploading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            onClick={addSection}
            disabled={isUploading}
          >
            <Plus className="w-5 h-5 mr-2" />
            Add Bill
          </button>
        </div>
      </div>

      <div className="flex flex-col space-y-4 mb-3 mt-6">
        <Modal
          children={
            <BillManagementUI
              employeeAddSection={employeeAddSection}
              handleUpload={handleUpload}
              isUploading={isUploading}
              toggleModal={toggleModal}
              formData={formData}
              employeeBills={formDataEmployee}
            />
          }
          isOpen={isOpenModal}
          toggleModal={toggleModal}
          modalButtonTitle={"Continue"}
          modalHeading={"Upload and Analyze"}
          isUploading={isUploading}
        />

      </div>

      {timelineItems.length > 0 && (
        <div className="mt-8" aria-live="polite">
          <h4 className="text-lg font-medium mb-4 text-gray-200">Progress</h4>
          <Timeline>
            {timelineItems.map((item, index) => (
              <TimelineItem key={index} title={item.title} status={item.status} />
            ))}
          </Timeline>
        </div>
      )}

      {uploadStatus && (
        <div
          className={`p-4 mt-6 rounded-md ${uploadStatus.includes("failed")
            ? "bg-red-900 text-red-200"
            : "bg-green-900 text-green-200"
            }`}
          role="alert"
          aria-live="assertive"
        >
          {uploadStatus}
        </div>
      )}
    </div>
  );

  const renderEmployeeExpenseBill = () => (
    <>
      <p className="text-xl pb-2 text-indigo-500 flex flex-col items-center justify-center">
        <span className="text-white">Welcome back</span>
        <span>{reviewInfo?.name}</span>
      </p>
      <h3 className="text-xl font-medium mb-4 text-gray-200 flex flex-col gap-6">
        <div className="flex w-full justify-between items-center">
          <p className="text-sm font-regular text-gray-100 opacity-65">
            Step 2 of 3
          </p>
          <button
            className={`
        text-[16px] font-regular flex gap-1 items-center
        ${isEmployeeUploading
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-gray-100 opacity-65 hover:opacity-100'
              }
      `}
            onClick={() => !isEmployeeUploading && setCurrentEmployeeStep(1)}
            disabled={isEmployeeUploading}
          >
            <ArrowLeft size={18} />
            Back
          </button>
        </div>
        <div className="flex items-center justify-between">
          Trip Bill Upload
        </div>
      </h3>
      {formDataEmployee.map((data, index) => (
        <div key={index} className="mb-8 p-4 border border-gray-700 rounded-lg">
          {formDataEmployee.length > 1 && (
            <button
              onClick={() => removeEmployeeSection(index)}
              disabled={isEmployeeUploading}
              className="p-1.5 bg-white rounded-full text-black hover:bg-white transition-colors mb-6"
            >
              <Trash size={16} />
            </button>
          )}
          <div className="mb-6">
            <label htmlFor={`image-${index}`} className="block mb-2 text-sm font-medium text-gray-300">
              Choose an image
            </label>
            {data.preview ? (
              <div className="relative">
                <img src={data.preview} alt="Preview" className="max-w-full h-auto rounded-lg shadow-md" />
                <button
                  onClick={() => removeEmployeeImage(index)}
                  className="absolute top-2 right-2 p-1 bg-red-500 rounded-full text-white hover:bg-red-600 transition-colors"
                  disabled={isEmployeeUploading}
                >
                  <X size={16} />
                </button>
              </div>
            ) : (
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <Image size={26} className="mx-auto text-gray-400 mb-4" />
                  <div className="flex text-sm text-gray-400">
                    <label
                      htmlFor={`image-${index}`}
                      className={`relative cursor-pointer bg-gray-700 rounded-md font-medium text-blue-400 hover:text-blue-300 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500 ${isEmployeeUploading ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                      <span className="p-2 rounded-lg">Upload a file</span>
                      <input
                        id={`image-${index}`}
                        name="image"
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={(e) => handleEmployeeFileChange(index, e)}
                        className="sr-only"
                        disabled={isEmployeeUploading}
                      />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-gray-400">PNG, JPG, PDF up to 10MB</p>
                </div>
              </div>
            )}
            {formEmployeeErrors[`image-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`image-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`type-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Expense Type
            </label>
            <select
              id={`type-${index}`}
              name="type"
              value={data.type}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`type-${index}`] ? 'border-red-500' : 'border-[#373737]'
                } rounded-md shadow-sm p-2 text-white ${isEmployeeUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={isEmployeeUploading}
            >
              <option value="">Select a bill</option>
              {getAvailableEmployeeBillOptions(formDataEmployee, index, EMPLOYEE_BILL_OPTIONS).map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {formEmployeeErrors[`type-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`type-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`description-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Description
            </label>
            <input
              type="description"
              id={`description-${index}`}
              name="description"
              value={data.description}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              disabled={isEmployeeUploading}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`description-${index}`] ? 'border-red-500' : 'border-[#373737]'
                } rounded-md shadow-sm p-2 text-white ${isEmployeeUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
            />
            {formEmployeeErrors[`description-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`description-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`location-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Location
            </label>
            <input
              type="text"
              id={`location-${index}`}
              name="location"
              value={data.location}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              disabled={isEmployeeUploading}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`location-${index}`] ? 'border-red-500' : 'border-[#373737]'
                } rounded-md shadow-sm p-2 text-white ${isEmployeeUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
            />
            {formEmployeeErrors[`location-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`location-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`billTypeEmployee-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Bill Type
            </label>
            <select
              id={`billTypeEmployee-${index}`}
              name="bill_type"
              value={data.bill_type}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              disabled={isEmployeeUploading}
              className="block w-full bg-[#1F1F1F] border border-[#373737] rounded-md shadow-sm p-2 text-white"
            >
              <option value="vendor">Vendor</option>
              <option value="employee">Employee</option>
            </select>
          </div>
          <div className="mb-4">
            <label htmlFor={`baseAmount-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Base Amount
            </label>
            <input
              type="number"
              id={`baseAmount-${index}`}
              onWheel={numberInputOnWheelPreventChange}
              name="baseAmount"
              value={data.baseAmount}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              disabled={isEmployeeUploading}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`baseAmount-${index}`] ? 'border-red-500' : 'border-[#373737]'
                } rounded-md shadow-sm p-2 text-white ${isEmployeeUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
            />
            {formEmployeeErrors[`baseAmount-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`baseAmount-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`gstAmount-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              GST Amount
            </label>
            <input
              type="number"
              id={`gstAmount-${index}`}
              onWheel={numberInputOnWheelPreventChange}
              name="gstAmount"
              value={data.gstAmount}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              disabled={isEmployeeUploading}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`gstAmount-${index}`] ? 'border-red-500' : 'border-[#373737]'
                } rounded-md shadow-sm p-2 text-white ${isEmployeeUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
            />
            {formEmployeeErrors[`gstAmount-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`gstAmount-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`totalAmount-${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Total Amount
            </label>
            <input
              type="number"
              id={`totalAmount-${index}`}
              onWheel={numberInputOnWheelPreventChange}
              name="totalAmount"
              value={data.totalAmount}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              disabled={true}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`totalAmount-${index}`] ? 'border-red-500' : 'border-[#373737]'
                } rounded-md shadow-sm p-2 text-white opacity-75 cursor-not-allowed`}
            />
            {formEmployeeErrors[`totalAmount-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`totalAmount-${index}`]}</p>
            )}
          </div>
          <div>
            <label
              htmlFor={`date-${index}`}
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Date
            </label>
            <input
              type="date"
              id={`date-${index}`}
              name="date"
              value={data.date}
              onChange={(e) => handleEmployeeInputChange(index, e)}
              className={`block w-full bg-[#1F1F1F] border ${formEmployeeErrors[`date-${index}`] ? "border-red-500" : "border-[#373737]"
                } rounded-md shadow-sm p-2 text-white`}
              disabled={isEmployeeUploading}
              max={new Date().toISOString().split('T')[0]}
              min={new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().split('T')[0]}
            />
            {formEmployeeErrors[`date-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formEmployeeErrors[`date-${index}`]}</p>
            )}
          </div>
        </div>
      ))}
      <div className="flex flex-col space-y-4 mb-3 mt-6">
        <button
          type="button"
          className={`text-gray-900 bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-2.5 py-1.5 text-center inline-flex items-center justify-center ${isEmployeeUploading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          onClick={employeeAddSection}
          disabled={isEmployeeUploading}
        >
          <Plus className="w-5 h-5 mr-2" />
          Add Bill
        </button>
      </div>
      <button
        onClick={onEmployeeReimbursementSubmit}
        className={`w-full px-4 py-2 rounded-md transition-colors text-black ${isEmployeeUploading
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-blue-600 hover:bg-blue-700'
          }`}
        disabled={isEmployeeUploading}
      >
        {!isEmployeeUploading ? "Submit" : "uploading..."}
      </button>

      {timelineItems.length > 0 && (
        <div className="mt-8" aria-live="polite">
          <h4 className="text-lg font-medium mb-4 text-gray-200">Progress</h4>
          <Timeline>
            {timelineItems.map((item, index) => (
              <TimelineItem key={index} title={item.title} status={item.status} />
            ))}
          </Timeline>
        </div>
      )}
    </>
  )

  const renderBankInfo = () => (
    <div className={`${glassPanelClass} space-y-6`}>
      <h3 className="text-xl font-medium mb-4 text-gray-200 flex flex-col gap-6">
        <div className="flex w-full justify-between items-center">
          <p className="text-sm font-regular text-gray-100 opacity-65">
            Step 3 of 3
          </p>
          {/* <button
            className="text-[16px] font-regular text-gray-100 opacity-65 flex gap-1 items-center"
            onClick={() => setCurrentStep(2)}
          >
            <ArrowLeft size={18} />
            Back
          </button> */}
        </div>
        <div className="flex items-center gap-6">
          Your Bank Information
        </div>
      </h3>
      {!isBankInfoExist &&
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
          <p className="font-bold">Bank Information Not Found</p>
          <p>Please contact the central team to add your bank information. You cannot add it directly.</p>
        </div>
      }
      <div className="space-y-4 mb-6">
        <div>
          <label
            htmlFor="employee_code"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            Bank Name
          </label>
          <input
            type="text"
            id="bank_name"
            name="bank_name"
            value={bankInfo?.bank_name}
            onChange={handleBankInfo}
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
            disabled
          />
        </div>
        <div>
          <label
            htmlFor="employee_code"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            Account Number
          </label>
          <input
            type="number"
            id="account_number"
            name="account_number"
            value={bankInfo.account_number}
            onChange={handleBankInfo}
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
            disabled
          />
        </div>
        <div>
          <label
            htmlFor="hub"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            {`Account Holder's Name`}
          </label>
          <input
            type="text"
            id="account_holder_name"
            name="account_holder_name"
            value={bankInfo.account_holder_name}
            onChange={handleBankInfo}
            disabled
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
          />
        </div>
        <div>
          <label
            htmlFor="hub"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            IFSC Code
          </label>
          <input
            type="text"
            id="ifsc_code"
            name="ifsc_code"
            value={bankInfo.ifsc_code}
            disabled
            onChange={handleBankInfo}
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
          />
        </div>
      </div>
      <button
        onClick={() => onBankInfoSubmit()}
        className={`w-full px-4 py-2 rounded-md transition-colors bg-white text-black`}
      >
        Continue
      </button>
    </div>
  )

  const renderEmployeeBankInfo = () => (
    <>
      <h3 className="text-xl font-medium mb-4 text-gray-200 flex flex-col gap-6">
        <div className="flex w-full justify-between items-center">
          <p className="text-sm font-regular text-gray-100 opacity-65">
            Step 3 of 3
          </p>
          {/* <button
            className="text-[16px] font-regular text-gray-100 opacity-65 flex gap-1 items-center"
            onClick={() => setCurrentEmployeeStep(2)}
          >
            <ArrowLeft size={18} />
            Back
          </button> */}
        </div>
        <div className="flex items-center gap-6">
          Your Bank Information
        </div>
      </h3>
      {!isBankInfoExist &&
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
          <p className="font-bold">Bank Information Not Found</p>
          <p>Please contact the central team to add your bank information. You cannot add it directly.</p>
        </div>
      }
      <div className="space-y-4 mb-6">
        <div>
          <label
            htmlFor="employee_code"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            Bank Name
          </label>
          <input
            type="text"
            id="bank_name"
            name="bank_name"
            value={bankInfo?.bank_name}
            onChange={handleBankInfo}
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
            disabled
          />
        </div>
        <div>
          <label
            htmlFor="employee_code"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            Account Number
          </label>
          <input
            type="number"
            id="account_number"
            name="account_number"
            value={bankInfo.account_number}
            onChange={handleBankInfo}
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
            disabled
          />
        </div>
        <div>
          <label
            htmlFor="hub"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            {`Account Holder's Name`}
          </label>
          <input
            type="text"
            id="account_holder_name"
            name="account_holder_name"
            value={bankInfo.account_holder_name}
            onChange={handleBankInfo}
            disabled
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
          />
        </div>
        <div>
          <label
            htmlFor="hub"
            className="block text-sm font-medium text-gray-300 mb-1"
          >
            IFSC Code
          </label>
          <input
            type="text"
            id="ifsc_code"
            name="ifsc_code"
            value={bankInfo.ifsc_code}
            disabled
            onChange={handleBankInfo}
            className={`block w-full bg-[#1F1F1F]
              } rounded-md shadow-sm p-2 text-white`}
          />
        </div>
      </div>
      <button
        onClick={() => onEmployeeBankInfoSubmit()}
        className={`w-full px-4 py-2 rounded-md transition-colors bg-white text-black`}
      >
        Continue
      </button>
    </>
  )


  const getSelectedHubLabel = (hubId) => {
    if (!hubId) return '-';
    const hub = hubs.find((h) => h.id === hubId);
    return hub ? `${hub.location} (${hub.state} - ${hub.zone})` : hubId;
  };

  const getSubmissionHubName = () => {
    if (reimbursementType === 'hubsetup') {
      return getSelectedHubLabel(formDataHubsetup.hub_name);
    }
    return getSelectedHubLabel(reviewInfo.hub_name);
  };

  const renderBankDetailsSummary = () => {
    const hubName = getSubmissionHubName();
    const employeeMailId = reviewInfo.email || '-';

    return (
      <>
        <div className="bg-gray-800 p-4 rounded-lg border border-gray-600 mt-4 text-left">
          <p className="text-sm text-gray-300 mb-3">Submission Details:</p>
          <div className="space-y-2 text-sm text-gray-200">
            <p><span className="text-gray-400">Hub Name:</span> {hubName}</p>
            <p><span className="text-gray-400">Employee Email ID:</span> {employeeMailId}</p>
          </div>
        </div>

        {!bankInfo?.account_number ? (
          <div className="bg-gray-800 p-4 rounded-lg border border-gray-600 mt-4 text-left">
            <p className="text-sm text-gray-300 mb-2">Bank Account Details:</p>
            <p className="text-sm text-gray-400">Bank account details are not available on file.</p>
          </div>
        ) : (
          <div className="bg-gray-800 p-4 rounded-lg border border-gray-600 mt-4 text-left">
            <p className="text-sm text-gray-300 mb-3">Bank Account Details:</p>
            <div className="space-y-2 text-sm text-gray-200">
              <p><span className="text-gray-400">Bank Name:</span> {bankInfo.bank_name || '-'}</p>
              <p><span className="text-gray-400">Account Holder:</span> {bankInfo.account_holder_name || '-'}</p>
              <p><span className="text-gray-400">Account Number:</span> {bankInfo.account_number || '-'}</p>
              <p><span className="text-gray-400">IFSC Code:</span> {bankInfo.ifsc_code || '-'}</p>
            </div>
          </div>
        )}
      </>
    );
  };

  const renderonSuccess = () => (
    <div className="w-full h-screen flex flex-col gap-28 pt-10 animate-slide-in-right">
      <div className="flex flex-col items-center gap-6">
        <CircleCheckBig className="w-16 h-16 text-white animate-bounce" />
        <p className="text-2xl ">Completed</p>
      </div>
      <div className="text-center">
        <p className="text-white mb-4">You have successfully submitted your Information</p>
        {claimId && (
          <div className="bg-gray-800 p-4 rounded-lg border border-gray-600">
            <p className="text-sm text-gray-300 mb-2">Your Claim ID:</p>
            <p className="text-lg font-mono font-bold text-green-400">{formatClaimId(claimId)}</p>
            <p className="text-xs text-gray-400 mt-2">Please save this ID for your records</p>
          </div>
        )}

        {renderBankDetailsSummary()}
      </div>
    </div>
  )

  const renderEmployeeSuccess = () => (
    <div className="w-full h-screen flex flex-col gap-28 pt-10 animate-slide-in-right">
      <div className="flex flex-col items-center gap-6">
        <CircleCheckBig className="w-16 h-16 text-white animate-bounce" />
        <p className="text-2xl ">Completed</p>
      </div>
      <div className="text-center">
        <p className="text-white mb-4">You have successfully submitted your Information</p>
        {claimId && (
          <div className="bg-gray-800 p-4 rounded-lg border border-gray-600">
            <p className="text-sm text-gray-300 mb-2">Your Claim ID:</p>
            <p className="text-lg font-mono font-bold text-green-400">{formatClaimId(claimId)}</p>
            <p className="text-xs text-gray-400 mt-2">Please save this ID for your records</p>
          </div>
        )}

        {renderBankDetailsSummary()}
      </div>
    </div>
  )

  const renderReviewInformationForm = () => (
    <div className="grid gap-6 xl:grid-cols-[320px_minmax(0,1fr)]">
      <div className={`${glassPanelClass} space-y-4`}>
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-gray-200">
            Select Reimbursement Type
          </label>
          <div className="relative">
            <select
              value={reimbursementType}
              onChange={(e) => setReimbursementType(e.target.value)}
              className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:bg-gray-750"
              style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
            >
              {Object.entries(reimbursementOptions).map(([value, label]) => (
                <option key={value} value={value} className="bg-gray-800">
                  {label}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <ChevronsUpDown className="w-5 h-5 text-gray-400" />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center space-x-2 py-2">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-sm font-semibold">
              1
            </div>
            <div className="w-12 h-0.5 bg-gray-600" />
            <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center text-gray-400 text-sm font-semibold">
              2
            </div>
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-2xl font-bold text-white mb-2">Review Your Information</h3>
          <p className="text-gray-400 text-sm">Step 1 of 2</p>
        </div>
      </div>

      <div className={`${glassPanelClass} space-y-6`}>
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
            <span className="ml-3 text-gray-300">Loading user data...</span>
          </div>
        ) : !formDataHubsetup.employee_id ? (
          <div className="bg-red-900/20 border border-red-500/30 rounded-xl p-6" role="alert">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-semibold text-red-400">Employee Information Not Found</h3>
                <p className="mt-1 text-sm text-red-300">
                  You must be part of the organization to submit a reimbursement request. Please contact your administrator for assistance.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="space-y-2">
              <label htmlFor="employee_id" className="block text-sm font-semibold text-gray-200">
                Employee ID
              </label>
              <input
                type="text"
                id="employee_id"
                name="employee_id"
                value={formDataHubsetup.employee_id}
                onChange={handleHubsetupInputChange}
                className={`w-full px-4 py-3 bg-gray-800 border ${formErrors.employee_id ? 'border-red-500' : 'border-gray-600'
                  } rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200`}
                disabled
              />
              {formErrors.employee_id && (
                <p className="text-sm text-red-400 flex items-center">
                  <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {formErrors.employee_id}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <label htmlFor="hub_name" className="block text-sm font-semibold text-gray-200">
                Hub
              </label>
              {hubs && hubs.length > 0 ? (
                <div className="relative">
                  <select
                    id="hub_name"
                    name="hub_name"
                    value={formDataHubsetup.hub_name}
                    onChange={handleHubsetupInputChange}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:bg-gray-750"
                    style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
                  >
                    <option value="" className="bg-gray-800">
                      Select a hub
                    </option>
                    {hubs.map((hub) => (
                      <option key={hub.id} value={hub.id} className="bg-gray-800">
                        {`${hub.location} (${hub.state} - ${hub.zone})`}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronsUpDown className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              ) : (
                <div className="bg-yellow-900/20 border border-yellow-500/30 rounded-xl p-4" role="alert">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-semibold text-yellow-400">No Hubs Assigned</h3>
                      <p className="mt-1 text-sm text-yellow-300">
                        There are no hubs attached to your name. Please contact your administrator for assistance.
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {formErrors.hub_name && (
                <p className="text-sm text-red-400 flex items-center">
                  <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {formErrors.hub_name}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <label htmlFor="month" className="block text-sm font-semibold text-gray-200">
                Select Month
              </label>
              <div className="relative">
                <select
                  id="month"
                  name="month"
                  value={formDataHubsetup.month}
                  onChange={handleHubsetupInputChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:bg-gray-750"
                  style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
                >
                  <option value="" className="bg-gray-800">
                    Select a month
                  </option>
                  {currentMonths.map((month) => (
                    <option key={month} value={month} className="bg-gray-800">
                      {month}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <ChevronsUpDown className="w-5 h-5 text-gray-400" />
                </div>
              </div>
              {reviewErrors['month'] && (
                <p className="text-sm text-red-400 flex items-center">
                  <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {reviewErrors['month']}
                </p>
              )}
            </div>
          </div>
        )}

        {formDataHubsetup.employee_id && (
          <div className="pt-4">
            <button
              onClick={handleNextClick}
              disabled={!formDataHubsetup.employee_id || !formDataHubsetup.hub_name || isLoading}
              className={`w-full px-6 py-4 rounded-xl font-semibold text-lg transition-all duration-200 transform ${formDataHubsetup.employee_id && formDataHubsetup.hub_name && !isLoading
                  ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 hover:scale-105 shadow-lg hover:shadow-xl'
                  : 'bg-gray-600 text-gray-400 cursor-not-allowed'
                }`}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2" />
                  Processing...
                </div>
              ) : (
                'Next'
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );

  const renderHubSetupBillForm = () => (
    <>
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-medium mb-4 text-gray-200 flex flex-col gap-6">
          <div className="flex w-full justify-between items-center">
            <p className="text-sm font-regular text-gray-100 opacity-65">
              Step 2 of 2
            </p>
          </div>
          Add Bills
        </h3>
        <button
          className={`text-[16px] font-regular flex gap-1 items-center text-gray-100 opacity-65 hover:opacity-100`}
          onClick={() => setCurrentHubsetupStep(1)}
        >
          <ArrowLeft size={18} />
          Back
        </button>
      </div>
      {expenses.map((expense, index) => (
        <div key={index} className="mb-8 p-4 border border-gray-700 rounded-lg">
          {expenses.length > 1 && (
            <button
              onClick={() => removeExpense(index)}
              disabled={isLoading}
              className="p-1.5 bg-white rounded-full text-black hover:bg-white transition-colors mb-6"
            >
              <Trash size={16} />
            </button>
          )}
          <div className="mb-6">
            <label htmlFor={`image-${index}`} className="block mb-2 text-sm font-medium text-gray-300">
              Choose an image
            </label>
            {expense?.preview ? (
              <div className="relative">
                <img src={expense.preview} alt="Preview" className="max-w-full h-auto rounded-lg shadow-md" />
                <button
                  onClick={() => removeExpenseImage(index)}
                  className="absolute top-2 right-2 p-1 bg-red-500 rounded-full text-white hover:bg-red-600 transition-colors"
                  disabled={isUploading}
                >
                  <X size={16} />
                </button>
              </div>
            ) : (
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <Image size={26} className="mx-auto text-gray-400 mb-4" />
                  <div className="flex text-sm text-gray-400">
                    <label
                      htmlFor={`image-${index}`}
                      className={`relative cursor-pointer bg-gray-700 rounded-md font-medium text-blue-400 hover:text-blue-300 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500 ${isUploading ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                      <span className="p-2 rounded-lg">Upload a file</span>
                      <input
                        id={`image-${index}`}
                        name="image"
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={(e) => handleHubsetupFileChange(index, e)}
                        className="sr-only"
                        disabled={isUploading}
                      />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-gray-400">PNG, JPG, PDF up to 10MB</p>
                </div>
              </div>
            )}
            {formErrors[`image-${index}`] && (
              <p className="mt-1 text-sm text-red-500">{formErrors[`image-${index}`]}</p>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor={`billType_setup_${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Bill Type
            </label>
            <select
              id={`billType_setup_${index}`}
              name="bill_type"
              value={expense.bill_type}
              onChange={(e) => handleExpenseChange(index, e)}
              className="block w-full bg-[#1F1F1F] border rounded-md shadow-sm p-2 text-white"
            >
              <option value="vendor">Vendor</option>
              <option value="employee">Employee</option>
            </select>
          </div>
          <div className="mb-4">
            <label htmlFor={`baseAmount_${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Base Amount
            </label>
            <input
              type="number"
              id={`baseAmount_${index}`}
              onWheel={numberInputOnWheelPreventChange}
              name="baseAmount"
              value={expense.baseAmount}
              onChange={(e) => handleExpenseChange(index, e)}
              className="block w-full bg-[#1F1F1F] border rounded-md shadow-sm p-2 text-white"
              placeholder="Enter Base Amount"
            />
          </div>
          <div className="mb-4">
            <label htmlFor={`gstAmount_${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              GST Amount
            </label>
            <input
              type="number"
              id={`gstAmount_${index}`}
              onWheel={numberInputOnWheelPreventChange}
              name="gstAmount"
              value={expense.gstAmount}
              onChange={(e) => handleExpenseChange(index, e)}
              className="block w-full bg-[#1F1F1F] border rounded-md shadow-sm p-2 text-white"
              placeholder="Enter GST Amount"
            />
          </div>
          <div className="mb-4">
            <label htmlFor={`totalAmount_${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Total Amount
            </label>
            <input
              type="number"
              id={`totalAmount_${index}`}
              onWheel={numberInputOnWheelPreventChange}
              name="totalAmount"
              value={expense.totalAmount}
              onChange={(e) => handleExpenseChange(index, e)}
              disabled={true}
              className="block w-full bg-[#1F1F1F] border rounded-md shadow-sm p-2 text-white opacity-75 cursor-not-allowed"
              placeholder="Auto-calculated"
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="date"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Date
            </label>
            <input
              type="date"
              id={`date_${index}`}
              name="date"
              value={expense.date}
              onChange={(e) => handleExpenseChange(index, e)}
              className={`block w-full bg-[#1F1F1F] border border-[#373737] rounded-md shadow-sm p-2 text-white`}
              max={new Date().toISOString().split('T')[0]} // Set max to the current date
            />
          </div>
          <div className="mb-4">
            <label htmlFor={`user_remarks_${index}`} className="block text-sm font-medium text-gray-300 mb-1">
              Remarks
            </label>
            <textarea
              id={`user_remarks_${index}`}
              name="user_remarks"
              value={expense.user_remarks}
              onChange={(e) => handleExpenseChange(index, e)}
              className="block w-full bg-[#1F1F1F] border rounded-md shadow-sm p-2 text-white"
              placeholder="Enter Remarks"
            ></textarea>
          </div>
        </div>
      ))}
      <div className="flex flex-col space-y-4 mb-3 mt-6">
        <button
          type="button"
          className="text-gray-900 bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-2.5 py-1.5 text-center inline-flex items-center justify-center"
          onClick={addExpense}
          disabled={isLoading}
        >
          <Plus className="w-5 h-5 mr-2" />
          Add Bill
        </button>
      </div>
      <button
        onClick={handleHubsetupExpensesUpload}
        disabled={isLoading || expenses.length === 0 || expenses.some(e => !e.baseAmount || !e.gstAmount || !e.totalAmount || !e.user_remarks)}
        className={`w-full px-4 py-2 rounded-md transition-colors ${isLoading || expenses.length === 0 || expenses.some(e => !e.baseAmount || !e.gstAmount || !e.totalAmount || !e.user_remarks)
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-green-600 hover:bg-green-700'
          } text-white`}
      >
        {isLoading ? 'Submitting...' : 'Submit'}
      </button>
      {error && <p className="mt-2 text-red-500">{error}</p>}
      {uploadStatus && <p className="mt-2 text-green-500">{uploadStatus}</p>}
    </>
  );

  const renderSuccess = () => (
    <div className="w-full h-screen flex flex-col gap-28 pt-10 animate-slide-in-right">
      <div className="flex flex-col items-center gap-6">
        <CircleCheckBig className="w-16 h-16 text-white animate-bounce" />
        <p className="text-2xl ">Completed</p>
      </div>
      <div className="text-center">
        <p className="text-white mb-4">You have successfully submitted your information.</p>
        {claimId && (
          <div className="bg-gray-800 p-4 rounded-lg border border-gray-600">
            <p className="text-sm text-gray-300 mb-2">Your Claim ID:</p>
            <p className="text-lg font-mono font-bold text-green-400">{formatClaimId(claimId)}</p>
            <p className="text-xs text-gray-400 mt-2">Please save this ID for your records</p>
          </div>
        )}
        {renderBankDetailsSummary()}
      </div>
    </div>
  );

  const renderHubsReimbursementSteps = () => (
    <>
      {currentStep === 1 && renderReviewInformation()}
      {currentStep === 2 && renderImageUpload()}
      {currentStep === 3 && renderBankInfo()}
      {currentStep === 4 && renderonSuccess()}
    </>
  );

  const renderHubsetupReimbursementSteps = () => (
    <>
      {currentHubsetupStep === 1 && renderReviewInformationForm()}
      {currentHubsetupStep === 2 && renderHubSetupBillForm()}
      {currentHubsetupStep === 3 && renderSuccess()}
    </>
  )

  const renderEmployeeReimbursementSteps = () => (
    <>
      {currentEmployeeStep === 1 && renderEmployeeReviewInformation()}
      {currentEmployeeStep === 2 && renderEmployeeExpenseBill()}
      {currentEmployeeStep === 3 && renderEmployeeBankInfo()}
      {currentEmployeeStep === 4 && renderEmployeeSuccess()}
    </>
  );

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#01030b] px-4 py-10">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 right-0 h-72 w-72 rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute left-0 top-40 h-80 w-80 rounded-full bg-fuchsia-500/10 blur-[160px]" />
        <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black via-transparent" />
      </div>
      <div className="relative z-10 mx-auto w-full max-w-3xl space-y-10">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-2xl font-bold text-white shadow-lg shadow-black/40">
            <img
              src={APP_LOGO_PUBLIC_SRC}
              alt="Brand logo"
              className="h-10 w-10 rounded object-contain"
              loading="eager"
            />
          </div>
          <h1 className="text-3xl font-semibold text-white">{TITLE_HEADING_NAME}</h1>
          <p className="mt-2 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1 text-xs uppercase tracking-widest text-slate-300">
            {reimbursementOptions[reimbursementType]} · workflow
          </p>
        </div>

        {reimbursementType === 'hubs'
          ? renderHubsReimbursementSteps()
          : reimbursementType === 'hubsetup'
            ? renderHubsetupReimbursementSteps()
            : renderEmployeeReimbursementSteps()}

        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-slate-500">Secure reimbursement processing system</p>
        </div>
      </div>
    </div>
  );
};

const FieldError = ({ message }) => (
  <p className="text-xs font-medium text-red-300/90">{message}</p>
);

const InsightCard = ({ title, subtitle, icon, active }) => (
  <div
    className={`rounded-2xl border border-white/10 p-4 text-left shadow-inner shadow-black/30 ${active ? "bg-white/10" : "bg-white/5"
      }`}
  >
    <div
      className={`mb-3 inline-flex h-9 w-9 items-center justify-center rounded-2xl text-sm font-semibold ${active ? "bg-blue-500 text-white" : "bg-slate-800 text-slate-200"
        }`}
    >
      {icon}
    </div>
    <p className="text-xs uppercase tracking-wide text-slate-400">{title}</p>
    <p className="text-sm font-semibold text-white">{subtitle}</p>
  </div>
);

const Stepper = ({ currentStep, steps }) => (
  <div className="rounded-2xl border border-white/5 bg-slate-950/40 px-4 py-5">
    <div className="flex items-center">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isComplete = currentStep > stepNumber;
        const isActive = currentStep === stepNumber;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center gap-2 text-center">
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-full border text-sm font-semibold ${isComplete
                    ? "border-emerald-400 bg-emerald-500/20 text-emerald-100"
                    : isActive
                      ? "border-blue-400 bg-blue-500/20 text-blue-100"
                      : "border-white/10 bg-white/5 text-slate-400"
                  }`}
              >
                {isComplete ? <CheckCircle className="h-4 w-4" /> : stepNumber}
              </div>
              <p className={`text-xs font-medium ${isActive || isComplete ? "text-white" : "text-slate-400"}`}>{label}</p>
            </div>
            {index !== steps.length - 1 && <div className="mx-2 h-px flex-1 bg-white/10" />}
          </React.Fragment>
        );
      })}
    </div>
  </div>
);

export default Expense;